import { selectMaintenanceStatus } from '@hozana/api/selectors'
import { useSelector } from '@hozana/redux/hooks'
import { cookie } from '@hozana/storage/cookies'
import { GTM } from '@hozana/tracking/gtm'

import { QUERY_ACTION } from 'general/constants'
import { COOKIES, COOKIES_CONFIG } from 'general/managers/cookies/constants'
import { POPINS } from 'general/managers/popins/constants'

import { useUser } from 'modules/user/hooks/useUser'

import { PromptType } from './constants'
import { usePromptsManagement } from './usePromptsManagement'

const popinOptions = {
  onDismissed: (close?: () => void) => {
    GTM.trackEvent(GTM.EVENTS.PROMPT_MAIL_DELIVERY_ISSUE_DISMISSED)
    close?.()
  },
  onValid: (close?: () => void) => {
    GTM.trackEvent(GTM.EVENTS.PROMPT_MAIL_DELIVERY_ISSUE_CLICKED)
    close?.()
  },
}

const onPop = () => {
  cookie.save(COOKIES.mailDeliveryIssue, true, COOKIES_CONFIG.ONE_YEAR)
  GTM.trackEvent(GTM.EVENTS.PROMPT_MAIL_DELIVERY_ISSUE_DISPLAYED)
}

/**
 * ### MailDeliveryIssuePromptManager ###
 *
 * Manage the invalid email prompt.
 */
export const MailDeliveryIssuePromptManager: TFC = () => {
  const me = useUser()
  const isMaintenanceStateActive = useSelector((state) => selectMaintenanceStatus(state))

  usePromptsManagement({
    type: PromptType.MAIL_DELIVERY_ISSUE,
    show:
      me.isLogged &&
      !cookie.load(COOKIES.mailDeliveryIssue) &&
      !isMaintenanceStateActive &&
      (me.mailDeliveryIssues?.invalid || me.mailDeliveryIssues?.hardBounce || me.mailDeliveryIssues?.spamReport),
    delay: 3000, // 3s
    actionKey: QUERY_ACTION.MAIL_DELIVERY_ISSUE,
    onPop,
    popinName: POPINS.MailDeliveryIssuePromptPopin,
    popinOptions,
  })

  return null
}
